import _get from 'lodash/get';

export const shouldDisplayProfilesGate = state => _get(state, 'lock.shouldDisplayProfilesGate');
